<template>
  <a-card title="测试用例">
    <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
        <a-input placeholder="Case ID" v-model:value="formSearch.case_id" />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="任务 ID" v-model:value="formSearch.task_id" />
      </a-form-item>
      <a-form-item  label="工具类型"  name="tool_id">
        <a-select
            :allowClear="true"
            show-search
            option-filter-prop="label"
            style="width: 100px;"
          v-model:value="formSearch.tool_id"
          :options="ToolIDOptions"
        />
      </a-form-item>
      <a-form-item  label="任务类型"  name="style_id">
        <a-select
            :allowClear="true"
            show-search
            option-filter-prop="label"
            style="width: 230px;"
          v-model:value="formSearch.style_id"
          :options="TaskStyleGroupOptions"
        />
      </a-form-item>
      <a-form-item   label="任务子类型"  name="sub_type">
        <a-select
          :allowClear="true"
        style="width:140px;"
          v-model:value="formSearch.sub_type"
          :options="SubTypeOptions"
          placeholder="SubType"
        />
      </a-form-item>
      <a-form-item  >
        <a-input placeholder="模板 ID" v-model:value="formSearch.template_id" />
      </a-form-item>
       <a-form-item  label="标签"  name="labels">
        <a-select
          :allowClear="true"
          mode="tags"
          show-search
          option-filter-prop="label"
          style="width:140px;"
          v-model:value="formSearch.labels"
          :options="labelOptions"
          placeholder="标签"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          @click="handleTableChange()"
          shape="circle"
        >
        <template #icon><SearchOutlined /></template>
        </a-button>
      </a-form-item>
      <a-form-item>
        <TestcaseAddon
        :item="{is_task: false}"
      />
      </a-form-item>
      <a-form-item v-if="selectedRowKeys.length > 0">
        <a-button @click="exportSelectedToCsv" >导出当前选中CSV</a-button>
      </a-form-item>
    </a-form>
    <div style="margin: 10px auto;">
      <div v-if="(formSearch.style_id !== '' || formSearch.labels) || selectedRowKeys.length > 0">
        <TestcaseRun 
          :case="formSearch"
          :btnText="'运行全部' + '(' + runCount + ')' "
          :style="StyleNames[formSearch.style_id]"
          :batchBy="{
            ...formSearch,
            ids: selectedRowKeys,
          }"
        />
      </div>
    </div>
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
    <a-table 
      class="ant-table-striped"
      show-quick-jumper
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :expandable="{
        showExpandColumn: true,
      }"
      :row-selection="{
        type: 'checkbox',
        selectedRowKeys: selectedRowKeys,
        onChange: this.rowSelectionChange,
        select: this.rowSelectionSelect,
        selectAll: this.rowSelectionSelectAll,
      }" 
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >

      <template #task_id="{ record }">
       <a :href="'/home/creation/works?task_id=' + record.task_id" target="_blank">{{ record.task_id }}</a>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status == 1" color="green">有效</a-tag>
        <a-tag v-else color="red">作废</a-tag>
      </template>
      <template #labels="{ record }">
        <a-tag v-if="record.style_id !== ''" color="blue" >{{  StyleNames[record.style_id]  }}</a-tag>
        <a-tag v-for="label of record.labels" :key="label.id" >{{ label.name }}</a-tag>
      </template>
      <template #image_gallary="{ record }">
        <div class="img-thumbnail" style="width: 740px; display: flex;" >
            <a-image-preview-group >
              <div v-if="record.base_image_key" class="thumbnail-item">
                <video
                  v-if="/\.(mp4|avi|mov|webm|mkv)$/i.test(record.base_image_key)"
                  preload="none"
                  poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                  :src="rawImage(record.base_image_key)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-image
                  v-else
                  placehoder=false
                  :preview='{ src: previewImage(record.base_image_key)}'
                  :src="thumbnail(record.base_image_key)"
                />
                <a-tag color="blue" >原图</a-tag>
              </div>

              <div v-if="record.mask_image_key" class="thumbnail-item">
                <a-image 
                  placehoder=false
                  :preview="{src: rawImage(record.mask_image_key)}"
                  :src="thumbnail(record.mask_image_key)"
                />
                <a-tag color="black" >MASK</a-tag>
              </div>
              <div v-else class="thumbnail-item thumbnail-item-block" >
                NO MASK
              </div>
              <div v-if="record.refer_image_key" class="thumbnail-item">
                <video 
                  v-if="record.refer_image_key.indexOf('.mp4') > 0"
                  preload="none"
                  :src="rawImage(record.refer_image_key)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-image 
                  v-else
                  placehoder=false
                  :preview='{ src: rawImage(record.refer_image_key)}'
                  :src="thumbnail(record.refer_image_key)"
                />
                <a-tag color="orange" >参考图</a-tag>
              </div> 
              <div v-else class="thumbnail-item thumbnail-item-block" >
                NO REFERENCE
              </div>
              <div v-if="record.work_image_key" class="thumbnail-item">
                 <video
                  v-if="/\.(mp4|avi|mov|webm|mkv)$/i.test(record.work_image_key)"
                  preload="none"
                  poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                  :src="rawImage(record.work_image_key)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-image
                  v-else
                  placehoder=false
                  :preview='{ src: previewImage(record.work_image_key)}'
                  :src="thumbnail(record.work_image_key)"
                />
                <a-tag color="green" >结果图</a-tag>
              </div>
               <div v-else class="thumbnail-item thumbnail-item-block" >
                NO RESULT
              </div>
            </a-image-preview-group>

          
        </div>
      </template>
     
      <template #expandedRowRender="{ record }">
        <div style="padding: 8px 16px; background: #fafafa;">
          <a-table
            :data-source="Object.entries(record).map(([key, value]) => ({ key, value }))"
            :columns="expandColumns"
            :pagination="false"
            size="small"
            bordered
            :row-key="r => r.key"
          />
        </div>
      </template>
       <template #operator_id="{ record }">
        <a target="_blank" :href="`/home/user?user_id=${record.operator_id}`">{{Operators[record.operator_id] ? Operators[record.operator_id] : record.operator_id}}</a>
      </template>

      <template #created_at="{ record }">
       <div>创建时间: {{ record.created_at.toLocaleString() }}</div>
       <div>修改时间: {{ record.updated_at.toLocaleString() }}</div>
      </template>
      <template #action="{ record }" >
        <div style="width: 80px;">
          <a-flex justify="space-between" gap="small" wrap="wrap">
            <TestcaseAddon @ok="() => { handleTableChange(pagination)}" :item="record" />
            <a-button @click="() => {handelReview(record)}"  type="primary" >详情</a-button>
            <TestcaseRun :case="record" :batchBy="{ ids: [record.id]}" />
            <a-popconfirm
              title="确认删除该测试用例吗？（如需恢复需要找研发）"
              ok-text="确定"
              cancel-text="不了"
              @confirm="handleDelete(record)"
            >
              <a-button  danger   >删除</a-button>
            </a-popconfirm>
            
          </a-flex>
        </div>
      </template>
    </a-table>
    
  </a-card>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'
import { Modal, message } from 'ant-design-vue';

import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { useStore } from 'vuex'
import {useRoute} from 'vue-router'
import {Operators} from '@/utils/macro'
import TestcaseRun from '@/components/TestcaseRun.vue'
import TestcaseAddon from '@/components/TestcaseAddon.vue'
import { TaskStyleGroupOptions, SubTypeOptions ,StyleNames, ToolIDOptions} from '@/utils/macro'
import {thumbnail , rawImage, previewImage} from '@/utils/image'

export default defineComponent({
  components: {
    SearchOutlined,
    TestcaseRun,
    TestcaseAddon,
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pageNo: 0,
      selectedRowKeys: [],
      selectedRows: [],
      StyleNames,
      Operators,
      ToolIDOptions,TaskStyleGroupOptions,
      preset_ids:"",
      SubTypeOptions:  SubTypeOptions,
      showFirst: false,
      statusOptions: [{
          label: "所有", value: '',
        },
        {
          label: "排队中", value: 0
        }, {
          label: "执行中", value: 1
        }, {
          label: "执行成功", value: 2
        }, {
          label: "执行失败", value: 3
        }, {
          label: "执行退出", value: 4
        }
      ],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',
      labelOptions: [],
       formSearch: {
        id: "0",
        ids: [],
        template_id: '',
        tool_id: '',
        style_id: '',
        sub_type: '',
        task_id: '',
        labels:[],
      },

      uploadLoading: false,
    }
  },
  computed: {
    runCount (){
      return this.selectedRowKeys.length > 0 ? this.selectedRowKeys.length : this.pagination.total
    },
    expandColumns() {
      return [
        { title: '字段', dataIndex: 'key', key: 'key', width: 200 },
        {
          title: '值',
          dataIndex: 'value',
          key: 'value',
          customRender: ({ record: row }) => {
            if (row.value && typeof row.value === 'object') {
              return h('pre', { style: { margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all', maxHeight: '400px', overflow: 'auto' } }, JSON.stringify(row.value, null, 2))
            }
            if (row.value === null || row.value === undefined) {
              return h('span', { style: { color: '#999' } }, '-')
            }
            if (row.value === '') {
              return h('a-tag', { color: 'default' }, '<empty>')
            }
            return row.value
          }
        }
      ]
    },
  },
  watch: {
    'formSearch.style_id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.handleTableChange()
        }
      }
    },
    'formSearch.labels': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.handleTableChange()
        }
      }
    },
  },
  mounted(){
    this.getLabels()
    const route = useRoute()
    if (route.query['task_id']) {
      this.formSearch.task_id = route.query['task_id']
    }
    if (route.query['user_id']) {
      this.formSearch.user_id = route.query['user_id']
    }
    if (route.query['queue_name']) {
      this.formSearch.queue_name = route.query['queue_name']
    }

    this.handleTableChange()
  },
  methods: {
    rowSelectionChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      console.log("selectedRowKeys", selectedRowKeys)
      this.selectedRows = selectedRows
    },
    rowSelectionSelect(record, selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      console.log("selectedRowKeys", selectedRowKeys)
      this.selectedRows = selectedRows
    },
    rowSelectionSelectAll(selected, selectedRowKeys, selectedRows)  {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    getLabels(){
      request.get(`/api/testcase/labels/`, {
        limit: 200,
      }).then((rsp) => {
        if (rsp.code == 0) {
          this.labelOptions = rsp.data.list.map((item) => {
            return {
              label: item.name,
              value: `${item.id}`,
            }
          })
        } else {
          message.error(rsp.msg)
        }
      }).catch((err) => {
        message.error(err.message)
      })
    },
    handleDelete(record){
      this.loading = true
      request.delete(`/api/testcase/cases/${record.id}`, null).then((rsp) => {
        if (rsp.code == 0) {
          message.success(rsp.msg)
          this.handleTableChange()
        } else {
          message.error(rsp.msg)
        }
      }).catch((err) => {
        message.error(err.message)
      }).finally(() => {
        this.loading = false
        this.handleTableChange()
      })
    },
    handelReview(record){
      this.$router.push({
        path: '/home/testcase/tasks',
        query: {
          case_id: record.id,
        }
      })
    },
    thumbnail,
    rawImage,
    previewImage,
    exportSelectedToCsv(){
      if (this.selectedRows.length === 0) {
        message.warning('请先选择要导出的用例')
        return
      }
      const escapeVal = (val) => {
        let s
        if (val === null || val === undefined) {
          s = ''
        } else if (typeof val === 'object') {
          s = JSON.stringify(val)
        } else {
          s = String(val)
        }
        if (/[",\n\r]/.test(s)) {
          s = '"' + s.replace(/"/g, '""') + '"'
        }
        return s
      }
      const keys = []
      const seen = new Set()
      if (this.selectedRows[0] && 'id' in this.selectedRows[0]) {
        keys.push('id')
        seen.add('id')
      }
      for (const row of this.selectedRows) {
        for (const k of Object.keys(row)) {
          if (!seen.has(k)) {
            seen.add(k)
            keys.push(k)
          }
        }
      }
      const header = keys.map(escapeVal).join(',')
      const lines = this.selectedRows.map(row => keys.map(k => escapeVal(row[k])).join(','))
      const csv = '\ufeff' + [header, ...lines].join('\r\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `testcases_${Date.now()}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      if (this.formSearch.labels.length > 1) {
        message.warning('最多只能选择一个标签')
        return
      }
      let limit = pagi.pageSize
      let orderBy = "id desc"
      let offset =  (pagi.current - 1) * pagi.pageSize
      // mode="tags" 允许输入文本，需将名称映射回 ID
      const labelNameToId = {}
      for (const opt of this.labelOptions) {
        labelNameToId[opt.label] = opt.value
      }
      const normalizedLabels = (this.formSearch.labels || []).map(v => labelNameToId[v] || v)
      const rsp = await request.get('/api/testcase/cases/', {
        offset: offset,
        limit: limit,
        order_by: orderBy,
        ...this.formSearch,
        labels: normalizedLabels.join(','),
        // after_cursor: afterCursor,
        // before_cursor: beforeCursor,
      })
      this.loading = false
      if (rsp.data.list) {
        this.dataSource = [].concat(rsp.data.list)
        for(let item of this.dataSource) {
          item.created_at = new Date(item.created_at).toLocaleString()
          item.updated_at = new Date(item.updated_at).toLocaleString()
        }
      } else {
        this.dataSource = []
      }
     
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`

      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
    
  },
  setup(props, context) {
   
    return {
      h,
      uploadInput: null,
      columns: [
      {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '用例名称',
          dataIndex: 'case_name',
          key: 'case_name',
          width:100,
        },
        {
          title: '图例',
          dataIndex: 'base_image_key',
          key: 'base_image_key',
          slots: { customRender: 'image_gallary' },
        },
        //  {
        //   title: 'Prompt',
        //   dataIndex: 'prompt',
        //   key: 'prompt',
        // },
        {
          title: '标签',
          dataIndex: 'labels',
          slots: { customRender: 'labels' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          // slots: { customRender: 'created_at' },
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          slots: { customRender: 'operator_id' },
        },
         {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
        // {
        //   title: '任务开始时间',
        //   dataIndex: 'task_start_at',
        //   key: 'task_start_at',
        //   slots: { customRender: 'task_start_at' },
        // },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.thumbnail-wraps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.prompt-container {
  cursor: pointer;
  max-height: 350px;
  max-width: 100px;
  overflow-y: scroll;
}
.prompt-container:hover {
  color: red;
}
.thumbnail-item {
  position:inherit;
  display: inline-block;
  /* flex-direction: row; */
  width: 180px;
  margin: 2px;
}
.thumbnail-item-block{
  background: #EFEFEF;
  text-align: center;
}
</style>
